import { FormControl, ValidatorFn } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorService {
  customPatternValid(config: any): ValidatorFn {
    return (control: FormControl) => {
      return this.checkControl(config, control);
    };
  }

  private checkControl(config: any, control: FormControl): Object {
    const urlRegEx: RegExp = config.pattern;

    if (control.value && !urlRegEx.test(control.value)) {
      const errorKey = config.errorType;
      return {
        [errorKey]: true
      };
    } else {
      return null;
    }
  }
}
